(function () {
  document.addEventListener(
    'click',
    function (evt) {
      var trigger = evt.target.closest('[data-focus-search]');
      if (!trigger) return;

      document.addEventListener(
        'drawerOpen.NavDrawer',
        function () {
          var input = document.querySelector('#NavDrawer .search-bar--drawer input[type="search"]');
          if (input) input.focus();
        },
        { once: true },
      );
    },
    true,
  );
})();
